import React from 'react'

import {
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Button,
  FormControl,
  FormLabel,
} from '@chakra-ui/react'
import { Spacer } from 'src/components/__legacy__/spacer/spacer'
import { ApiResponse } from 'src/lib/api-client'

import { ModalCancelButton } from '../../../../../../../../lib/chakra-theme/components'
import { IcfDocumentType, icfDocumentTypeText } from '../entity'

type Props = {
  isRequiredReAgreementConfirmDocuments: ApiResponse<'ListICFDocumentsItem'>[]
  selectedDocUids: string[]
  onToggle: (e: React.ChangeEvent<HTMLInputElement>) => void
  onClose: () => void
  onConfirm: () => void
}

export const IcfDocumentReAgreementConfirmRenewal: React.FC<Props> = ({
  isRequiredReAgreementConfirmDocuments,
  selectedDocUids,
  onToggle,
  onClose,
  onConfirm,
}) => {
  return (
    <>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>再同意確認</ModalHeader>
        <ModalBody>
          <Text>
            ※再同意が必要な文書を含む同意済状態の説明にはアラートが表示され、再同意を実施する必要があります。
          </Text>
          <Text>
            再同意不当の場合、対象文書を含む説明に再同意は不要となります。
          </Text>
          <Spacer size={8} />
          <Table>
            <Thead>
              <Tr>
                <Th w="15%">文書ID</Th>
                <Th w="40%">文書名</Th>
                <Th w="15%">版数</Th>
                <Th w="15%">文書の種類</Th>
                <Th w="15%">再同意</Th>
              </Tr>
            </Thead>
            <Tbody>
              {isRequiredReAgreementConfirmDocuments.map(doc => {
                return (
                  <Tr key={doc.uid}>
                    <Td>{doc.numberingId}</Td>
                    <Td>{doc.name}</Td>
                    <Td>{doc.version}</Td>
                    <Td>{icfDocumentTypeText[doc.type as IcfDocumentType]}</Td>
                    <Td>
                      <Stack direction="row">
                        <FormControl display="flex" alignItems="center">
                          <FormLabel mb="0">
                            {selectedDocUids.includes(doc.uid) ? (
                              <Text as="span">必要</Text>
                            ) : (
                              <Text as="span" color="gray.400">
                                不要
                              </Text>
                            )}
                          </FormLabel>
                          <Switch
                            size="lg"
                            colorScheme="green"
                            value={doc.uid}
                            isChecked={selectedDocUids.includes(doc.uid)}
                            onChange={onToggle}
                          />
                        </FormControl>
                      </Stack>
                    </Td>
                  </Tr>
                )
              })}
            </Tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <ModalCancelButton />
          <Button
            type="submit"
            onClick={() => {
              onConfirm()
              onClose()
            }}
          >
            確認
          </Button>
        </ModalFooter>
      </ModalContent>
    </>
  )
}
